import Cookies from "js-cookie";

export const getAccountsDashboardUrl = () => process.env.REACT_APP_ACCOUNTS_DASHBOARD_URL;

export const DOMAIN_COOKIE_NAME = process.env.REACT_APP_DOMAIN_COOKIE_NAME;
export const DAARA_COOKIE_NAME = process.env.REACT_APP_DAARA_COOKIE_NAME;
export const DAARA_TOKEN_PREFIX = process.env.REACT_APP_DAARA_TOKEN_PREFIX;
export const REFRESH_TOKEN_NAME = process.env.REACT_APP_REFRESH_NAME;

export const getCookie = (_name = DOMAIN_COOKIE_NAME) => {
  const cookie = Cookies.get(_name);
  return cookie;
};

export function getEnvVariable(key) {
    const value = process.env[key];
    if (!value) {
      throw new Error(
        `Environment variable "${key}" is not set. The application cannot proceed.`
      );
    }
    return value;
}

export const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const extractFilenameFromContentDisposition = (header) => {
    const match = /filename="?([^";]+)"?/i.exec(header || '');
    return match ? match[1] : null;
};
